import { request } from '@umijs/max';

// 获取当前登录用户信息
export function currentUser(options?: Record<string, any>) {
  return request('/api/system/current_user', {
    method: 'GET',
    ...(options || {}),
  });
}

// 获取图片验证码
export function getCaptcha() {
  return request('/api/system/captcha', {
    method: 'GET',
  });
}

// 系统登录
export function login(body: any, options?: Record<string, any>) {
  return request('/api/system/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

// 查询系统用户列表
export async function getSystemUsers(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: Record<string, any>,
) {
  return request('/api/system/users', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

// 创建系统用户
export function addSystemUser(data?: Record<string, any>) {
  return request('/api/system/users', {
    method: 'POST',
    data,
  });
}

// 更新系统用户信息
export function updateSystemUser(sysUserId: string, data?: Record<string, any>) {
  return request(`/api/system/users/${sysUserId}`, {
    method: 'PUT',
    data,
  });
}

// 更新系统用户密码
export function updatePwd(data?: Record<string, any>) {
  return request('/api/system/update_pwd', {
    method: 'POST',
    data,
  });
}
